export const playerConfig = {
  maxWithdrawCount: "Max Withdraw Count",
  maxWithdrawBasedMinutes: "Max Withdraw Based Minutes",
  save: "Save",
  withdrawCountLimit: "*Withdraw Count Limit",
  doNotChange: "*Do Not Change!",
};
